module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "data-btnmark": "add"
    },
    on: {
      "click": function($event) {
        return _vm.showAdd('', 1)
      }
    }
  }, [_vm._v("新增")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.xsjlList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "套餐包名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.pkgname
          }
        }, [_vm._v(" " + _vm._s(scope.row.pkgname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.price
          }
        }, [_vm._v(" " + _vm._s(scope.row.price) + " 元")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "过期日期",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.validdate
          }
        }, [_vm._v(" " + _vm._s(scope.row.validdate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.createtime
          }
        }, [_vm._v(" " + _vm._s(scope.row.createtime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.remark
          }
        }, [_vm._v(" " + _vm._s(scope.row.remark))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "260"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.showAdd(scope.row, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 2),
            expression: "scope.row.status == 2"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handleUpper(scope.row, 1)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v(" 上架 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 1),
            expression: "scope.row.status == 1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handleUpper(scope.row, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v(" 下架 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.showAdd(scope.row, 3)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v("\n              编辑")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handleUpper(scope.row, 3)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.totalOne,
      "current-page": _vm.pageIndexOne
    },
    on: {
      "current-change": _vm.currentChangeOne
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.seeshow,
      "visible": _vm.showGive,
      "center": true,
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showGive = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "套餐包名称 :",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入套餐包名称",
      "maxlength": "10"
    },
    model: {
      value: (_vm.pkgname),
      callback: function($$v) {
        _vm.pkgname = $$v
      },
      expression: "pkgname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "套餐包价格 :",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入套餐包价格",
      "maxlength": "6"
    },
    model: {
      value: (_vm.price),
      callback: function($$v) {
        _vm.price = $$v
      },
      expression: "price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "套餐包类型：",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.pkgtype),
      callback: function($$v) {
        _vm.pkgtype = $$v
      },
      expression: "pkgtype"
    }
  }, _vm._l((_vm.genderArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "过期日期 :",
      "label-width": "100px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "disabled-date": _vm.disableBeforeToday,
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.validdate),
      callback: function($$v) {
        _vm.validdate = $$v
      },
      expression: "validdate"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    model: {
      value: (_vm.yxqxOne),
      callback: function($$v) {
        _vm.yxqxOne = $$v
      },
      expression: "yxqxOne"
    }
  }, [_vm._v("永不")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "邀请人分佣比 :",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "请输入邀请人分佣比",
      "maxlength": "2",
      "onkeyup": "value=(value.replace(/\\D/g,'')==''?'':parseInt(value))"
    },
    model: {
      value: (_vm.profit_sharing_rate),
      callback: function($$v) {
        _vm.profit_sharing_rate = $$v
      },
      expression: "profit_sharing_rate"
    }
  }), _vm._v("  %  \n      ")], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "套餐包明细：",
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "package-detail-layout"
  }, [_c('el-select', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleSelectChange
    },
    model: {
      value: (_vm.selectedProductIds),
      callback: function($$v) {
        _vm.selectedProductIds = $$v
      },
      expression: "selectedProductIds"
    }
  }, _vm._l((_vm.producttype), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.productname,
        "value": item.productid
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "package-input-group"
  }, _vm._l((_vm.productItems), function(item, idx) {
    return _c('div', {
      key: idx,
      staticClass: "input-row"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "8px"
      }
    }, [_vm._v(_vm._s(item.product.productname))]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "disabled": item.product.producttype == 2 ? true : false,
        "placeholder": item.product.producttype === 1 ? '请输入数量' : '数量',
        "maxlength": "4"
      },
      on: {
        "input": function (val) { return _vm.handleQuantityInput(item, val); }
      },
      model: {
        value: (item.num),
        callback: function($$v) {
          _vm.$set(item, "num", $$v)
        },
        expression: "item.num"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "8px"
      }
    }, [_vm._v(_vm._s(item.product.unit))])], 1)
  }), 0)], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "备注 :",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注：",
      "autosize": {
        minRows: 2,
        maxRows: 8
      },
      "maxlength": "150",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showGive = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.isSeePopup,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isSeePopup = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('ul', {
          staticClass: "drawer_title"
        }, [_c('li', [_vm._v("订单详情")])])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "drawer_div"
  }, [_c('ul', {
    staticClass: "drawer_ul"
  }, [_c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("套餐包名称：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.pkgname))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("套餐包类型：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.pkgtype == 1 ? '交付宝套餐' : ''))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("价格：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.price) + "元")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("过期日期：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.validdate ? _vm.formDetails.validdate : '永不过期'))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("邀请人返佣比：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.profit_sharing_rate) + "%")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("套餐明细：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-table"
    }
  }, _vm._l((_vm.formDetails.details), function(item) {
    return _c('ul', {
      key: item.productid
    }, [_c('li', [_vm._v(_vm._s(item.producttype == 1 ? '【产品】' : '【权益】') + _vm._s(item.productname) + " " + _vm._s(item.producttype == 2 ? '' :
      item.num) + " " + _vm._s(item.unit))])])
  }), 0)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.remark))])])]), _vm._v(" "), _c('div', {
    staticClass: "drawer_foot"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.cancelForm
    }
  }, [_vm._v("关 闭")])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("套餐包管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09ae6626!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/platformManagement/productpackage.vue
// module id = 1633
// module chunks = 3